import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventManagerService } from 'src/app/core/services/event-manager/event-manager.service';
import { UserAdapterService } from 'src/app/core/services/http/user/adapters/user-adapter.service';
import { FormGroupService } from 'src/app/shared/form-error/form-group.service';
import { EventContent } from '../../../core/services/event-manager/models/event-content';
import { EventType } from '../../../constants/events-type';
import { takeUntil } from 'rxjs/operators';
import { getFormGroup } from './form-group/my-profile-user-edit.form-group';
import { AuthenticatedUserService } from '../../../core/services/http/authenticated-user/authenticated-user.service';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
import { Authority } from '../../../constants/authority';
import { MembershipService } from '../../../core/services/http/membership/membership.service';
import { forkJoin, Observable } from 'rxjs';
import { AuthFactoryService } from '../../../core/services/auth/auth-factory.service';

@Component({
  selector: 'app-my-profile-edit-modal',
  templateUrl: './my-profile-edit-modal.component.html'
})
export class MyProfileEditModalComponent extends ConfirmationModalComponent implements OnInit {
  form = getFormGroup();
  public isStudent = false;
  protected readonly Authority = Authority;
  constructor(
    protected modalRef: BsModalRef,
    protected eventManager: EventManagerService,
    protected userAdapterService: UserAdapterService,
    protected formGroupService: FormGroupService,
    protected authenticatedUserService: AuthenticatedUserService,
    protected membershipService: MembershipService,
    protected authService: AuthFactoryService
  ) {
    super(modalRef, eventManager);
  }

  ngOnInit() {
    this.loadUser();
  }

  onConfirm(): void {
    if (!this.form) {
      return;
    }

    this.formGroupService.validateFormGroup(this.form);

    if (this.form.invalid) {
      return;
    }

    const observables: Array<Observable<any>> = [];

    if (this.form.controls.defaultSchool?.value) {
      observables.push(this.membershipService.changeDefaultSchool(this.form.controls.defaultSchool?.value));
    }

    const adultRoleList = [Authority.Admin, Authority.Staff, Authority.Teacher, Authority.Substitute];

    if (this.authService.service.hasAnyAuthority(adultRoleList)) {
        const requestBody = this.userAdapterService.formGroupToUserSelfUpdateRequest(this.form);

        if (requestBody) {
          observables.push(
              this.authenticatedUserService
                  .patch(requestBody)
          );
        }
    }

    if (observables.length > 0) {
        this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, true));
        forkJoin(observables)
            .pipe(takeUntil(this.destroyNotify))
            .subscribe(() => {
                this.onSuccess();
            });
    }
  }

  private loadUser(): void {

    this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, true));

    this.authenticatedUserService
        .getAuthenticatedUser()
        .pipe(takeUntil(this.destroyNotify))
        .subscribe(user => {
          if (!this.form) {
            return;
          }

          this.userAdapterService.authenticatedUserToFromGroupData(user, this.form);
          this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, false));
          this.isStudent = this.authService.service.getSchoolUserAuthority()?.role === Authority.Student;
        });
  }
}
